// extracted by mini-css-extract-plugin
export default {"Question":"Question_Question__5Mevk","TheQuestion":"Question_TheQuestion__0Z3sj","QuestionShown":"Question_QuestionShown__qva0v","QuestionHidden":"Question_QuestionHidden__JCVFQ"};